/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { AppContext } from '../App';
import AgendaStreamingContextProvider from '../common/AgendaStreamingContextProvider';
import { handleCanonicalUrl } from '../data/seo/seoUtils';
import { useAbsolutePath } from '../data/seo/seoRouteUtils';
import { getFavouriteMatchesFromStorage } from '../data/utils/getFavouriteMatchesFromStorage';
import { parseWindowLocationHash } from '../data/utils/parseWindowLocationHash';
import { useWidgetContext, WidgetContext } from '../data/widgets/WidgetContext';
import { appConfig } from '../appConfig';
import AgendaStreaming from './agenda-streaming/AgendaStreaming';
import LiveCalendar from './calendar/LiveCalendar';
import Favorites from './favorites/Favorites';
import CasinoContainer from './CasinoContainer';
import LiveSuite from './live-suite/LiveSuite';
import LiveMatchDataFetcher from './match/LiveMatchDataFetcher';
import { getConfiguration } from '../data/utils/configuration';

export const LiveContext = React.createContext(null);
export const StreamingContext = React.createContext(null);

function getSportIdFromHash(){
    const parsedData =  parseWindowLocationHash(true);
    return parsedData && parsedData.sportId;
}

function getSortType() {
    let sortType = 'league';
    const item = localStorage.getItem('xs_live_sort_type');
    if (item) {
        sortType = item;
    }
    return sortType;
}

function Live(props) {
    const conf = getConfiguration();
    const appContext = React.useContext(AppContext);
    const [widgetContext] = useWidgetContext('#br_widget');
    const sportId = getSportIdFromHash() || 0;

    const initCtx = {
        resetted: false,
        section: props.section == 'calendar' ? 'calendar' : 'live-suite',
        navLiveSportsRef:null,
        navLiveSportsScroll: 0,
        sport: sportId,
        sports: null,
        tournaments:null,
        match:null,
        bet: null,
        expandedView:false,
        fastBet:false,
        showPopupFB: false,
        showKeyPad: false        
    }
    const [context, setContext] = useState({
        ...initCtx,
        favorites: getFavouriteMatchesFromStorage(),
        sortType: getSortType(),
        reset() {
            this.update({...initCtx, navLiveSportsRef:this.navLiveSportsRef, resetted:true});
        },
        update(updt) {
            setContext(prev => {
                return {...prev, ...updt};
            });
        },
        openLiveSuite(sport) {
            this.update({section: 'live-suite', sport: sport, match: null});
        },
        openMatch(match, updateNavLiveSportsScroll) {
            if(updateNavLiveSportsScroll === true)
                this.update({section: 'match', match, navLiveSportsScroll: this.navLiveSportsRef.scrollLeft});
            else{
                this.update({section: 'match', match});
            }
        },
        changeBet(bet) {
            this.update({bet: bet});
        },
        setSports(sports){
            this.update({sports});
        },
        setTournaments(tournaments){
            this.update({tournaments});
        },
        setExpandedView(expandedView){
            this.update({expandedView});
        },
        setNavLiveSportsRef(navLiveSportsRef){
            this.update({navLiveSportsRef});
        },
        toggleCalendar() {
            this.update({section: 'calendar',  navLiveSportsScroll: this.navLiveSportsRef.scrollLeft});
        },
        toggleCasino() {
            this.update({section: 'casino',  navLiveSportsScroll: this.navLiveSportsRef.scrollLeft});
        },
        toggleFavorite(match, idAggregata) {
            if (this.favorites[match.uniqueId] === undefined) {
                this.favorites[match.uniqueId] = {
                    ...match,
                    idAggregata
                };
            } else {
                delete this.favorites[match.uniqueId];
            }
            this.update({favorites: this.favorites});
        },
        setFavorites(favorites) {
            this.update({favorites});
        },
        toggleFavorites() {
            this.update({section: 'favorites', bet: null, navLiveSportsScroll: this.navLiveSportsRef.scrollLeft});
        },
        toggleAgendaStreaming() {
            this.update({section: 'agenda-streaming',  navLiveSportsScroll: this.navLiveSportsRef.scrollLeft});
        },
        setSortType(sortType) {
            this.update({sortType});
            localStorage.setItem('xs_live_sort_type', sortType);
        },
        toggleFastbet() {
            if(!this.fastBet)
                this.update({fastBet: true, showPopupFB : true});
            else
              this.update({fastBet: false, showPopupFB : false});
        },
        toggleshowPopupFB() {                
              this.update({showPopupFB : !this.showPopupFB});

        },
        initFastBet(input){
            this.update({showPopupFB : !this.showPopupFB});
            input.focus();
        }
    });

    const livePagePath = useAbsolutePath(appConfig.ROUTES.prematch['live'],null,null,true);
    useEffect(() => {
        handleCanonicalUrl(livePagePath);
    }, []);
    
    const [streamingContext,setStreamingContext] = useState({
        streamingId: null,
        streamingMatchId: null,
        streamingProps: null,
        toggleStreamingId: function(streamingProps,id,matchId) {
            setStreamingContext(function(prev) {
                return  {
                    ...prev,
                    streamingId: prev.streamingId==id?null:id,
                    streamingMatchId: matchId,
                    streamingProps: streamingProps
                }
            });
        }
    });

    (function useHandleResetLive () {
        if (appContext.resetLive && ! context.resetted) {
            context.reset();
            widgetContext.reset();
            console.log("context has been resetted")
        }

        useEffect(() => {
            appContext.setResetLive(false)
        }, [context.resetted]);

        useEffect(() => {
            if (appContext.resetLive === false) {
                context.update({resetted: false});
            }
        }, [appContext.resetLive]);
    })();
    
    return (
        <LiveContext.Provider value={context}>
            {(() => {
                switch (context.section) {
                    default:
                    case 'live-suite': {
                        return <LiveSuite sport={context.sport}/>;
                    }
                    case 'match': {
                        return (
                            <WidgetContext.Provider value={widgetContext}>
                                <StreamingContext.Provider value={streamingContext}>
                                    <LiveMatchDataFetcher match={context.match} tournaments={context.tournaments} />
                                </StreamingContext.Provider>
                            </WidgetContext.Provider>
                        );
                    }
                    case 'calendar': {
                        return <LiveCalendar sports={context.sports} />;
                    }
                    case 'casino': {
                        return <CasinoContainer src={conf.urlCasino} />;
                    }
                    case 'favorites': {
                        return <Favorites />;
                    }
                    case 'agenda-streaming': {
                        return (
                            <AgendaStreamingContextProvider>
                                <StreamingContext.Provider value={streamingContext}>
                                    <AgendaStreaming />
                                </StreamingContext.Provider>
                            </AgendaStreamingContextProvider>
                        );
                    }
                }
            })()}
        </LiveContext.Provider>
    );
}

export default Live;